import React from 'react';
import { SearchResultsPage } from './search-results';

export default function render(entry: any) {
    return <SearchResultsPage {...entry} />;
}
